import React from 'react';
import { ErrorBoundary as ErrorBoundaryAlternative } from 'react-error-boundary';
import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';

const globalBugsnagClient = window.bugsnagClient;

let bugsnagClient;

if (globalBugsnagClient) {
  bugsnagClient = bugsnag({
    apiKey: globalBugsnagClient.config.apiKey,
    appVersion: globalBugsnagClient.config.appVersion,
    notifyReleaseStages: globalBugsnagClient.config.notifyReleaseStages,
    releaseStage: globalBugsnagClient.config.releaseStage,
  });

  bugsnagClient.use(bugsnagReact, React);
}

export const ErrorBoundary =
  bugsnagClient?.getPlugin('react') || ErrorBoundaryAlternative;
